module.exports = __webpack_public_path__ + "img/blue.0976ea06.png";